import axios from 'axios';
import store from '../store';
import {API_GET_DOMAIN_GROUP_URL} from '../app/utils';

export function findDomainGroup(contactsGroupId, domainGroupPageSize){
	return function(dispatch){

		let request = "";

		if(domainGroupPageSize){
			request = API_GET_DOMAIN_GROUP_URL + '/' + contactsGroupId + '?pageSize=' + domainGroupPageSize;
		} else {
			request = API_GET_DOMAIN_GROUP_URL + '/' + contactsGroupId;
		}

		axios.get(request, {withCredentials: true}).then( response => {

			dispatch({
				type: "FIND_DOMAIN_GROUP",
				payload: response.data
			});

		});

	}
}

export function loadNewDomainGroup(selectedCollaboratorId, pageSize, nextPage){
	return function(dispatch){

        dispatch(isNewCollaboratorsListLoading(true));

		axios.get(API_GET_DOMAIN_GROUP_URL + '/' + selectedCollaboratorId + '?pageSize=' + pageSize + '&page=' + nextPage, {withCredentials: true}).then((response) => {
			dispatch({
				type: "LOAD_NEW_DOMAIN_GROUP",
				payload: response.data.domainGroups
			});

            dispatch(isNewCollaboratorsListLoading(false));
			dispatch(domainGroupNextPage(store.getState().domainGroupReducer.domainGroupNextPage + 1));
		});
	}
}

export function isNewCollaboratorsListLoading(boolean){
    return {
        type: "IS_NEW_COLLABORATORS_LIST_LOADING",
        payload: boolean
    };
}

export function domainGroupNextPage(int){
	return {
		type: "DOMAIN_GROUP_NEXT_PAGE",
		payload: int
	};
}

export function domainGroupPageSize(int) {
	return {
		type: "DOMAIN_GROUP_PAGE_SIZE",
		payload: int
	};
}

export function resetDomainGroup(){
	return function(dispatch){
		dispatch({
			type: "FIND_DOMAIN_GROUP",
			payload: null
		});
	}
}